export default __webpack_public_path__ + "static/media/bibooFig.dc33cf2a.png";